import { formatPhone } from '@ui/src';
import { BeneficiaryInfoTypes } from '../types';
import BeneficiaryContentRow from './content-row';

import cn from '../styles.module.css';

const BeneficiaryInfo = ({
  beneficiary,
  errors,
  countries,
  globalValidateError,
}: BeneficiaryInfoTypes) => {
  const paymentTypeArray = beneficiary.paymentType.split('_');

  const paymentType = paymentTypeArray
    ?.map(
      (typeValue) =>
        `${typeValue.charAt(0)}${typeValue.slice(1).toLocaleLowerCase()}`,
    )
    .join(' ');

  let sortCodeValue;

  if (beneficiary?.sortCode) {
    const regex = /.{1,2}/g;

    sortCodeValue = beneficiary?.sortCode
      ?.replace(/[^0-9]/g, '')
      ?.match(regex)
      ?.join('-');
  }

  return (
    <div className={`${cn.beneficiaryContent} ${cn.moreMargin}`}>
      <div className={cn.beneficiaryContentBlock}>
        <div className={cn.beneficiryContentColumn}>
          <BeneficiaryContentRow
            name="Transfer type"
            value={`${paymentType} ${
              beneficiary.currencyId ? `(${beneficiary.currency?.name})` : ''
            }`}
          />
          {beneficiary?.paymentType !== 'CASH_OVER_COUNTER' && (
            <BeneficiaryContentRow
              name="Account Number"
              value={beneficiary.iban || beneficiary.bankAccountNumber || '-'}
              error={
                errors?.iban?.message || errors?.bankAccountNumber?.message
              }
            />
          )}
          {beneficiary?.aba && (
            <BeneficiaryContentRow
              name="ABA"
              value={beneficiary.aba}
              error={errors?.aba?.message}
            />
          )}
          {beneficiary?.sortCode && (
            <BeneficiaryContentRow
              name="Sort Code"
              value={sortCodeValue as string}
              error={errors?.sortCode?.message}
            />
          )}

          {beneficiary?.paymentType === 'CASH_OVER_COUNTER' && (
            <>
              <BeneficiaryContentRow
                name="Collector contact"
                value={
                  beneficiary?.collectorContact
                    ? formatPhone(beneficiary?.collectorContact)
                    : '-'
                }
                error={errors?.collectorContact?.message}
              />
              <BeneficiaryContentRow
                name="Country"
                value={beneficiary?.country?.name || '-'}
                error={errors?.countryId?.message}
              />
            </>
          )}
        </div>
        <div className={cn.beneficiryContentColumn}>
          <BeneficiaryContentRow
            name="Type"
            value={
              beneficiary.beneficiaryType === 'INDIVIDUAL'
                ? 'Individual'
                : 'Company'
            }
            error={errors?.beneficiaryType?.message}
          />
          <BeneficiaryContentRow
            name="Nickname"
            value={beneficiary.nickname}
            error={errors?.nickname?.message}
          />
        </div>
      </div>
      {beneficiary?.paymentType !== 'CASH_OVER_COUNTER' && (
        <>
          <div className={cn.beneficiaryContentBlock}>
            <div className={cn.beneficiryContentColumn}>
              <BeneficiaryContentRow
                name="Address"
                value={beneficiary.address || '-'}
                error={errors?.address?.message}
              />
              <BeneficiaryContentRow
                name="City"
                value={beneficiary.city || '-'}
                error={errors?.city?.message}
              />
            </div>
            <div className={cn.beneficiryContentColumn}>
              <BeneficiaryContentRow
                name="Country"
                value={beneficiary?.country?.name || '-'}
                error={errors?.countryId?.message}
              />
              <BeneficiaryContentRow
                name="Post Code"
                value={beneficiary?.postCode || '-'}
                error={errors?.postCode?.message}
              />
            </div>
          </div>
          <div className={cn.beneficiaryContentBlock}>
            <div className={cn.beneficiryContentColumn}>
              <BeneficiaryContentRow
                name="Bank Name"
                value={beneficiary.bankName || '-'}
                error={errors?.bankName?.message}
              />
              <BeneficiaryContentRow
                name="BIC"
                value={beneficiary.bic || '-'}
                error={errors?.bic?.message}
              />
            </div>
            <div className={cn.beneficiryContentColumn}>
              <BeneficiaryContentRow
                name="Bank Country"
                value={
                  countries?.find(
                    (item) => item.value === beneficiary?.bankCountry,
                  )?.name || '-'
                }
                error={errors?.bankCountry?.message}
              />
              <BeneficiaryContentRow
                name="Bank address"
                value={beneficiary.bankAddress || '-'}
                error={errors?.bankAddress?.message}
              />
            </div>
          </div>
        </>
      )}
      {globalValidateError && (
        <div className={cn.globalValidateError}>{globalValidateError}</div>
      )}
    </div>
  );
};

export default BeneficiaryInfo;
